module.exports = __webpack_public_path__ + "static/media/Driveline_CV_Shaft_White.caf2645d.webp";